module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_sola_white-bc859a1a08d49385227625bdc984ff60.svg";